import { Spinner } from '@fluentui/react-components';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { getAuthFromQueryClient } from '../lib/auth/hooks';

const AdminLayout = lazy(() =>
  import('../pages/admin/AdminLayout').then((m) => ({
    default: m.AdminLayout,
  })),
);

export const Route = createFileRoute('/admin')({
  beforeLoad: async ({ context }) => {
    const auth = await getAuthFromQueryClient(context.queryClient);

    // Not authenticated - redirect to login
    if (!auth?.user) {
      throw redirect({
        to: '/login',
        search: { redirectTo: '/admin' },
      });
    }

    // Admin-only route
    if (auth.user.role !== 'admin') {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </Suspense>
  ),
});
